export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          移动入口
        </h2>
        <div className="max-w-lg mx-auto bg-background-50 rounded-2xl p-6 md:p-8 flex flex-col sm:flex-row items-center gap-6">
          <div className="w-20 h-20 rounded-2xl bg-primary-500 flex items-center justify-center flex-shrink-0">
            <i className="ri-smartphone-line text-3xl text-white"></i>
          </div>
          <div className="text-center sm:text-left">
            <h3 className="font-heading text-lg text-foreground-950 mb-2">随时随地，吃瓜不停</h3>
            <p className="text-sm text-foreground-600 mb-4">
              吃瓜入口移动端已覆盖主流平台，扫码或在应用商店搜索「吃瓜入口」即可获取每日大赛最新推送，地铁通勤、午休时间，大赛吃瓜在线随时看。
            </p>
            <span className="inline-flex items-center gap-2 px-5 py-2 bg-secondary-100 text-secondary-700 rounded-full text-xs font-medium whitespace-nowrap">
              <i className="ri-download-2-line"></i>
              各大应用商店均可下载
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}